import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class ReleaseNotes extends Vue {
  goToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}
